import { FC, IframeHTMLAttributes, useMemo } from "react";
import { OgData } from "@src/features/libraryItem/course/OpenGraphLinkPreview";

type Props = {
  mediaUrl: string;
  ogData: OgData | undefined;
  ogVideoIframeProps?: Partial<IframeHTMLAttributes<HTMLIFrameElement>>;
};

const OpenGraphVideoPlayerIframe: FC<Props> = (props) => {
  const ogVideoUrl = useMemo(() => {
    if (props.ogData?.["og:video:url"]) {
      return props.ogData["og:video:url"];
    }
    const youtubeEmbed = getYouTubeEmbedUrl(props.mediaUrl);
    if (youtubeEmbed) return youtubeEmbed;
    return props.mediaUrl;
  }, [props.ogData, props.mediaUrl]);
  if (!ogVideoUrl) return null;
  const videoHeight = props.ogData?.["og:video:height"] || 1;
  const videoWidth = props.ogData?.["og:video:width"] || 1;
  return (
    <iframe
      id={"video-iframe"}
      key={ogVideoUrl}
      title={props.ogData?.["og:title"]}
      src={ogVideoUrl}
      {...props.ogVideoIframeProps}
      style={{
        borderRadius: 12,
        outline: "none",
        border: "none",
        cursor: "pointer",
        alignSelf: "stretch",
        aspectRatio: `${videoWidth}/${videoHeight}`,
      }}
    />
  );
};

export default OpenGraphVideoPlayerIframe;

const getYouTubeEmbedUrl = (url: string): string | null => {
  const patterns = [
    /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&?#]+)/,
    /youtube\.com\/watch\?.*v=([^&]+)/,
  ];
  for (const pattern of patterns) {
    const match = url.match(pattern);
    if (match) return `https://www.youtube.com/embed/${match[1]}`;
  }
  return null;
};
